import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('alphaNum', /^[0-9a-zA-Z]*$/);
